import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { Carousel } from 'react-responsive-carousel'
import Loader from '../UI/Loader'
import GuideProfileAbout from './GuideProfileAbout'
import 'react-responsive-carousel/lib/styles/carousel.css'
import USER_FULL_INFO from './../../graphql/UserFullInfoGuide.graphql'

class FinishPage extends React.Component {
  componentWillMount() {
    if (!this.props.data.loading && !this.props.data.user.guideProfile) {
      this.props.history.push('/activity-guide-profile/description')
    }
  }

  goToActivitySteps() {
    this.props.history.push('/activity-steps')
  }

  render() {
    const { t } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { user } = this.props.data
    console.log(user)
    return (
      <div>
        <div className="steps-screen__guru-profile-container">
          <div className="guru-profile ">
            <div className="guru-profile__left-column">
              <GuideProfileAbout user={user} t={this.props.t} />
            </div>
            <div className="guru-profile__right-column" style={{ maxWidth: 450 }}>
              {this.props.data && user && user.guideProfile && user.guideProfile.photos && user.guideProfile.photos.length ? (
                <div className="finishPage__carousel">
                  <Carousel showArrows={true} showStatus={false} showThumbs={false} autoPlay={true} emulateTouch={true}>
                    {user.guideProfile.photos.map((photo, index) => (
                      <div className="carouselPhoto" key={index}>
                        <img src={photo.url} />
                      </div>
                    ))}
                  </Carousel>
                </div>
              ) : (
                <div>No photos here</div>
              )}
              <button
                className="btn btn-lg btn-primary btn-danger create-activity-btn"
                onClick={() => this.goToActivitySteps()}
                style={{ marginLeft: 0 }}
              >
                Create an activity
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  translate('guide'),
  graphql(USER_FULL_INFO, {
    options: {
      fetchPolicy: 'network-only'
    }
  })
)(FinishPage)



// WEBPACK FOOTER //
// src/components/Guide/FinishPage.jsx